export default __webpack_public_path__ + "static/media/no-notification.7e42ab18.png";